import script from "./DateRange.vue?vue&type=script&lang=ts&setup=true"
export * from "./DateRange.vue?vue&type=script&lang=ts&setup=true"

import "./DateRange.vue?vue&type=style&index=0&id=545eabe0&scoped=true&lang=css"
import "./DateRange.vue?vue&type=style&index=1&id=545eabe0&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-545eabe0"]])

export default __exports__